import PropTypes from 'prop-types';

const ChoicesPropType = PropTypes.arrayOf(PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string,
}));

export default ChoicesPropType;
